import React from "react";
import {Box, Button, Paper, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function ServerBackups({ backups, downloading, openDialog }) {
    return (
        <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6" gutterBottom>Управление бэкапами</Typography>

            <Button variant="outlined" sx={{ mr: 1, mb: 1 }} onClick={() => openDialog("backup")}>Создать бэкап</Button>
            <Button variant="outlined" sx={{ mr: 1, mb: 1 }} onClick={() => openDialog("restore")}>Восстановить бэкап</Button>
            <Button
                variant="outlined"
                sx={{ mb: 1 }}
                onClick={() => openDialog("download")}
                disabled={downloading}
            >
                {downloading ? (
                    <>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        Загрузка...
                    </>
                ) : (
                    "Скачать бэкап"
                )}
            </Button>
            <Typography variant="subtitle1" gutterBottom>Список бэкапов:</Typography>
            {backups.length > 0 ? (
                <Box
                    sx={{
                        maxHeight: 200,
                        overflowY: 'auto',
                        pr: 1, // немного отступа справа для скроллбара
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: '#2e3334',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#555',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#777',
                        },
                        scrollbarWidth: 'thin', // Firefox
                        scrollbarColor: '#555 #2e3334', // Firefox
                    }}
                >
                    {backups.map((backup, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography variant="body2">{backup.dateTime}</Typography>
                            <Typography variant="body2">{backup.sizeMb} МБ</Typography>
                        </Box>
                    ))}
                </Box>
            ) : (
                <Typography variant="body2">Бэкапы отсутствуют.</Typography>
            )}
        </Paper>
    );
}